import { render, staticRenderFns } from "./ConsumerTerms.vue?vue&type=template&id=3e544aa6&"
var script = {}
import style0 from "./ConsumerTerms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports